module.exports = __webpack_public_path__ + "img/iybi.0613cd89.png";